import React, { useEffect, useRef, useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';

const HomeVideo = () => {
    const videoId = "bseCgngL3pA";
    const [isMuted, setIsMuted] = useState(true);
    const playerRef = useRef(null);

    useEffect(() => {
        // Load YouTube IFrame API if not already loaded
        if (!window.YT) {
            const tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        // Define the global callback for when the API is ready
        window.onYouTubeIframeAPIReady = () => {
            initializePlayer();
        };

        // If the API is already loaded, initialize the player immediately
        if (window.YT && window.YT.Player) {
            initializePlayer();
        }

        function initializePlayer() {
            playerRef.current = new window.YT.Player('youtube-player', {
                videoId: videoId,
                playerVars: {
                    autoplay: 1,
                    mute: 1,
                    loop: 1,
                    playlist: videoId,
                    controls: 0,
                    modestbranding: 1,
                    rel: 0,
                    showinfo: 0,
                    iv_load_policy: 3,
                    enablejsapi: 1,
                    origin: window.location.origin
                },
                events: {
                    onReady: (event) => {
                        event.target.playVideo();
                        // Ensure it's muted at start to allow autoplay
                        event.target.mute();
                    },
                    onStateChange: (event) => {
                        // Restart video if it ends (looping)
                        if (event.data === window.YT.PlayerState.ENDED) {
                            event.target.playVideo();
                        }
                    }
                }
            });
        }

        return () => {
            // Clean up player on unmount
            if (playerRef.current) {
                playerRef.current.destroy();
            }
        };
    }, [videoId]);

    const toggleMute = () => {
        if (playerRef.current) {
            if (isMuted) {
                playerRef.current.unMute();
                setIsMuted(false);
            } else {
                playerRef.current.mute();
                setIsMuted(true);
            }
        }
    };

    return (
        <section className="relative w-screen left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] overflow-hidden bg-black h-[70svh] sm:h-[80svh] md:h-[90svh] mt-10 sm:mt-16 md:mt-24">
            {/* Cinematic Video Wrapper Centered with Minimal Scale (1.03) */}
            <div className="absolute top-1/2 left-1/2 min-w-full min-h-full w-auto h-auto transform -translate-x-1/2 -translate-y-1/2 pointer-events-none scale-[1.03]">
                <div id="youtube-player" className="w-full h-full aspect-video"></div>
            </div>

            {/* Audio Toggle Button - Fixed to bottom right */}
            <div className="absolute bottom-8 right-8 z-30">
                <button 
                    onClick={toggleMute}
                    className="flex items-center gap-3 bg-black/60 hover:bg-black/80 backdrop-blur-xl px-6 py-4 rounded-full text-white transition-all duration-300 shadow-2xl border border-white/20 group focus:outline-none scale-110 sm:scale-100"
                    aria-label={isMuted ? "Unmute" : "Mute"}
                >
                    {isMuted ? (
                        <>
                            <VolumeX size={22} className="text-white/80" />
                            <span className="text-[11px] font-bold uppercase tracking-[0.2em]">Unmute Audio</span>
                        </>
                    ) : (
                        <>
                            <Volume2 size={22} className="text-white" />
                            <span className="text-[11px] font-bold uppercase tracking-[0.2em]">Mute Audio</span>
                        </>
                    )}
                </button>
            </div>

            {/* Subtle Overlay Gradient */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-black/10 pointer-events-none"></div>
        </section>
    );
};

export default HomeVideo;
